export default "__VITE_ASSET__CBwQA3rv__"